import Replay from './Replay'

export default Replay
// eslint-disable-next-line import/export
export * from './Replay'
